import { Pipe, PipeTransform } from '@angular/core';
import { ModbusDeviceConfigModel } from '../../src/typings/api.location';

@Pipe({
    name: 'deviceConfiguration'
})
export class FormatDeviceConfigurationPipe implements PipeTransform {
    public transform(configuration?: ModbusDeviceConfigModel): string {
        return configuration ? `${configuration.templateName} ${configuration.templateVersion}` : `n/a`;
    }
}
